<template>
  <div class="row">
    <div class="col-12 col-md-6">
      <form role="form">
        <div class="form-group">
          <label>Nazwa</label>
          <input
            type="text"
            class="form-control"
            v-model="location.name"
            name="location_name"
          />
          <small v-show="errors.has('location_name')" class="text-danger">
            Pole wymagane!
          </small>
        </div>
        <div class="form-group">
          <label>Miasto</label>
          <input
            type="text"
            class="form-control"
            v-model="location.city"
            name="location_city"
          />
          <small v-show="errors.has('location_city')" class="text-danger">
            Pole wymagane!
          </small>
        </div>
        <div class="form-group">
          <label>Adres</label>
          <input
            type="text"
            class="form-control"
            v-model="location.address"
            name="location_address"
          />
          <small v-show="errors.has('location_address')" class="text-danger">
            Pole wymagane!
          </small>
        </div>
        <div class="form-group">
          <label>Kod pocztowy</label>
          <input
            type="text"
            class="form-control"
            v-model="location.post_code"
            name="location_post_code"
          />
          <small v-show="errors.has('location_post_code')" class="text-danger">
            Pole wymagane!
          </small>
        </div>
        <div class="form-group">
          <label>Godziny otwarcia</label>
          <input
            type="text"
            class="form-control"
            v-model="location.opening_hours"
            name="location_opening_hours"
          />
          <small
            v-show="errors.has('location_opening_hours')"
            class="text-danger"
          >
            Pole wymagane!
          </small>
        </div>
        <div class="form-group">
          <label>Nr tel</label>
          <input
            type="text"
            class="form-control"
            v-model="location.phone"
            name="location_phone"
          />
          <small v-show="errors.has('location_phone')" class="text-danger">
            Pole wymagane!
          </small>
        </div>
      </form>
      <div class="row">
        <div class="col-12">
          <div @click="saveChange" class="btn btn-primary">
            Zapisz
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TrainingCitiesForm",
  data() {
    return {
      location: {
        address: "",
        city: "",
        name: "",
        opening_hours: "",
        phone: "",
        post_code: ""
      }
    };
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      if (this.$route.params.id !== undefined) {
        this.$emit("loading", true);
        let url = `/${this.$route.params.shop_name}/${this.$route.params.shop_lang}/trainings/cities/${this.$route.params.id}`;
        this.$http
          .get(url)
          .then(resp => {
            this.location = resp.data;
            this.$emit("loading", false);
          })
          .catch(err => {
            this.$toastr.error(err);
            this.$emit("loading", false);
          });
      }
      this.$emit("loading", false);
    },
    saveChange() {
      this.$emit("loading", true);
      let url = `/${this.$route.params.shop_name}/${this.$route.params.shop_lang}/trainings/cities`;

      this.$http
        .customRequest({
          method: this.$route.params.id !== undefined ? "put" : "post",
          url:
            this.$route.params.id !== undefined
              ? `${url}/${this.$route.params.id}`
              : url,
          data: this.location
        })
        .then(() => {
          // console.log(resp);
          this.$toastr.success("Zrobione!");
          this.$emit("loading", false);
        })
        .catch(err => {
          this.$toastr.error(err);
        });
    }
  }
};
</script>
